import axios from "@/utils/axios.js";

/**
 * Получение списка подразделений
 */
function getDepartments() {
  return new Promise((resolve, reject) => {
    axios
      .get("departments?expand=parent")
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getDepartmentsSearch(value) {
  return new Promise((resolve, reject) => {
    axios
        .get(`departments?search[name]=${value}&expand=parent`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение дерева подразделений
 */
function getTreeDepartments(params) {
  return new Promise((resolve, reject) => {
    axios
      .get("departments/tree", { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
function getTreeDepartmentsChild(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`departments/tree/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Получение подразделения
 */
function getDepartment(id, expand) {
  return new Promise((resolve, reject) => {
    axios
      .get(`departments/${id}`, { params: { expand } })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Создание подразделения
 * @param {String} name
 * @param {Number} parent_id
 * @param {Array} user_ids
 */
function createDepartment(name, parent_id, userIds) {
  const departmentData = {
    parent_id,
    name,
    heads_ids: userIds,
  };
  return new Promise((resolve, reject) => {
    axios
      .post("departments", departmentData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Изменение подразделения
 * @param {Number} depId
 * @param {String} name
 * @param {Number} parent_id
 * @param {Array} userIds
 */
function updateDepartment(name, parent_id, userIds, depId) {
  const departmentData = {
    name,
    parent_id,
    heads_ids: userIds,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`departments/${depId}`, departmentData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Удаление подразделения
 * @param {Number} depId
 */
function deleteDepartment(depId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`departments/${depId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function restoreDepartment(depId) {
  return new Promise((resolve, reject) => {
    axios
        .put(`departments/${depId}/restore`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение родителя подразделения
 * @param depId
 * @returns {Promise<unknown>}
 */
function getDepartmentById(depId) {
  return new Promise((resolve, reject) => {
    axios
        .get(`departments/${depId}?expand=parent,heads`)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        });
  });
}

export {
  getDepartments,
  getDepartment,
  createDepartment,
  getTreeDepartments,
  updateDepartment,
  deleteDepartment,
  getDepartmentById,
  getTreeDepartmentsChild
};
